<template>
  <div class="group group--contentful group--sidebar">
    <h1 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h1 article__title">{{ article.name }}</h1>
    <h2 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h2 article__subtitle">{{ article.sub }}</h2>

    <module-rich-text
      
      :class="[article.sub ? `` : `mt20`]"
      :entry="article.richText"
    />

    <hr v-if="hasRelatedArticles" class="hr">

    <span
      v-if="hasRelatedArticles"
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="dt fw-bold c-accent h3 mb ">Related Articles</span>

    <ul v-if="hasRelatedArticles" class="related-articles-list">
      <li
        class="related-articles-list__item"
        @click="navigateToArticle(article.related[0])"
      >
        <a class="link tdn">
          <h3 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="p c-accent fw-bold mb0 related-articles-list__title">{{ article.related[0] && article.related[0].name }}</h3>
          <p class="related-articles-list__sub" v-clamp>{{ article.related[0].sub }}</p>
        </a>
      </li>

      <li
        class="related-articles-list__item"
        @click="navigateToArticle(article.related[1])"
        v-if="article.related[1]"
      >
        <a class="link tdn">
          <h3 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="p c-accent fw-bold mb0 related-articles-list__title">{{ article.related[1] && article.related[1].name }}</h3>
          <p class="related-articles-list__sub" v-clamp>{{ article.related[1].sub }}</p>
        </a>
      </li>
    </ul>

    <module-modal
      :modal="modalExternalData"
      v-show="showDisclaimer"
      @close="showDisclaimer = false"
    >

      <template slot="modal-footer">
        <module-button @click.native="showDisclaimer = false">No</module-button>
        <module-button @click.native="goToUrl">Yes</module-button>
      </template>
    </module-modal>

    <hr v-if="article.author && article.author.length" class="hr">

    <p 
      v-if="article.author" 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="article__author fw-bold c-accent p">
      <span class="dt fw-bold c-mid">Author</span>
      <span class="fw-medium">{{ article.author }}</span>
    </p>

    <hr v-if="article.source && article.source.length" class="hr">

    <p 
      v-if="article.source"
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="article__author fw-bold c-accent p">
      <span class="dt fw-bold c-mid">Article Source</span>
      <span class="fw-medium">{{ article.source }}</span>
    </p>

    <hr class="hr" v-if="article.copyright && article.copyright.length">
    <p v-if="article.copyright" class="p">{{ article.copyright.text }}</p>

    <hr v-if="article.reviews || article.tags" class="hr">

    <p v-if="article.reviews" class="p">Reviewed by {{ article.reviews }}</p>

    <ul v-if="article.tags" class="list list--tags">
      <li
        v-for="(tag, index) in article.tags"
        :key="index"
        class="list__item list__item--tag"
      >
        {{ tag }}
      </li>
    </ul>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Utils
import { toSlug } from 'utils/string';

// Components
import ModuleRichText from 'components/RichText';
import ModuleModal from 'components/Modal';

export default {
  name: 'view-article',

  // Components
  components: {
    ModuleRichText,
    ModuleModal,
  },

  data() {
    return {
      showDisclaimer: false,
      preUrl: null,
      modalExternalData: {
        title: 'You are now leaving the website.',
        copy: 'Your destination website is not controlled by our privacy statement. Please read the privacy statement of your destination website. Do you want to continue?',
      },
    };
  },

  // Computed
  computed: {
    ...mapGetters('contentful', ['article', 'topic', 'topics']),
    ...mapGetters('app', ['org']),

    hasRelatedArticles() {
      return this.article && this.article.related && this.article.related.length;
    },

    author() {
      return this.article && this.arcticle.author;
    },
  },

  // Methods
  methods: {
    ...mapActions('contentful', ['getArticle', 'getTopics']),

    goToUrl() {
      window.open(this.preUrl, '_blank');
      this.showDisclaimer = false;
    },

    navigateToArticle(article) {
      const { externalUrl } = article;

      if (externalUrl && this.org.show_disclaimer) {
        this.showDisclaimer = true;
        this.preUrl = externalUrl;
      } else if (externalUrl && !this.org.show_disclaimer) {
        this.preUrl = externalUrl;
        this.goToUrl();
      } else {
        this.$router.push({
          name: 'article',
          params: {
            topic: toSlug(this.topic(article.topicId).name),
            article: toSlug(article.name),
          },
          query: {
            topicId: article.topicId,
            articleId: article.id,
          },
        });
      }
    },
  },

  // Lifecycles
  created() {
    this.getArticle(this.$route.query.articleId);

    // Request topics to find topic ID of related articles
    if ( !this.topics || !this.topics.length ) this.getTopics();
  },
};
</script>



// WEBPACK FOOTER //
// Article.vue?0229b340